import React from 'react'
import { useToken } from 'app/hooks'
import CompactHeader from './CompactHeader'

const HeaderSection = () => {
	const { data: token } = useToken()

	return <CompactHeader />
}

export default React.memo(HeaderSection)
